"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upstreamOfThisAssetMessage = exports.onThisAssetMessage = exports.catalogLabelAssetTypeToLabelAssetType = exports.labelSubjectArea = exports.isLabelAssetType = exports.labelAssetType = exports.isLabelServiceAssetType = exports.labelServiceAssetType = void 0;
var Localize_1 = require("../../../../gen-src/Localize");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
/**
 * @internal
 */
exports.labelServiceAssetType = ['datasource', 'database', 'table', 'virtualConnection', 'virtualConnectionTable', 'flow', 'column'];
function isLabelServiceAssetType(value) {
    return exports.labelServiceAssetType.find(function (t) { return t === value; }) !== undefined;
}
exports.isLabelServiceAssetType = isLabelServiceAssetType;
/**
 * @internal
 */
exports.labelAssetType = ['CloudFile', 'DatabaseServer', 'DatabaseTable', 'File', 'Flow', 'PublishedDatasource', 'WebDataConnector', 'VirtualConnectionTable', 'VirtualConnection', 'Column'];
function isLabelAssetType(value) {
    return exports.labelAssetType.find(function (t) { return t === value; }) !== undefined;
}
exports.isLabelAssetType = isLabelAssetType;
/**
 * @internal
 */
exports.labelSubjectArea = ['View', 'Metric', 'metric', 'Workbook', 'workbook', 'EmbeddedDatasource', 'Field'];
function catalogLabelAssetTypeToLabelAssetType(type) {
    switch (type) {
        case 'WebDataConnector': return 'database';
        case 'DatabaseServer': return 'database';
        case 'CloudFile': return 'database';
        case 'File': return 'database';
        case 'DatabaseTable': return 'table';
        case 'Flow': return 'flow';
        case 'PublishedDatasource': return 'datasource';
        case 'VirtualConnection': return 'virtualConnection';
        case 'VirtualConnectionTable': return 'virtualConnectionTable';
        case 'Column': return 'column';
        case null: return null;
        case undefined: return undefined;
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(type);
            return null;
    }
}
exports.catalogLabelAssetTypeToLabelAssetType = catalogLabelAssetTypeToLabelAssetType;
function onThisAssetMessage(contentType) {
    if (!contentType) {
        return Localize_1.Messages.Label_direct_asset();
    }
    switch (contentType) {
        case 'column':
        case 'Column':
            return Localize_1.Messages.Label_direct_column();
        case 'database':
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector':
            return Localize_1.Messages.Label_direct_database();
        case 'table':
        case 'DatabaseTable':
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return Localize_1.Messages.Label_direct_table();
        case 'flow':
        case 'Flow':
            return Localize_1.Messages.Label_direct_flow();
        case 'datasource':
        case 'PublishedDatasource':
            return Localize_1.Messages.Label_direct_datasource();
        case 'virtualConnection':
        case 'VirtualConnection':
            return Localize_1.Messages.Label_direct_connection();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(contentType);
            return '';
    }
}
exports.onThisAssetMessage = onThisAssetMessage;
function upstreamOfThisAssetMessage(contentType) {
    if (!contentType) {
        return Localize_1.Messages.Label_upstream_asset();
    }
    switch (contentType) {
        case 'column':
        case 'Column':
            return Localize_1.Messages.Label_upstream_column();
        case 'database':
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector':
            return Localize_1.Messages.Label_upstream_database();
        case 'table':
        case 'DatabaseTable':
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return Localize_1.Messages.Label_upstream_table();
        case 'flow':
        case 'Flow':
            return Localize_1.Messages.Label_upstream_flow();
        case 'datasource':
        case 'PublishedDatasource':
        case 'EmbeddedDatasource':
            return Localize_1.Messages.Label_upstream_datasource();
        case 'virtualConnection':
        case 'VirtualConnection':
            return Localize_1.Messages.Label_upstream_connection();
        case 'View':
            return Localize_1.Messages.Label_upstream_view();
        case 'Workbook':
        case 'workbook':
            return Localize_1.Messages.Label_upstream_workbook();
        case 'Field':
            return Localize_1.Messages.Label_upstream_field();
        case 'Metric':
        case 'metric':
            return Localize_1.Messages.Label_upstream_metric();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(contentType);
            return '';
    }
}
exports.upstreamOfThisAssetMessage = upstreamOfThisAssetMessage;
//# sourceMappingURL=LabelAssetContent.js.map